/**
 * apps/web/src/main.tsx
 * -------------------------------------------------------
 * Purpose:
 *   Browser entrypoint for the React application.
 *
 * High-level data flow:
 *   - Creates the React Router data router.
 *   - Wraps the app in MantineProvider for consistent theming.
 *   - Mounts the SPA into the #root element.
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import { MantineProvider } from '@mantine/core';

import '@mantine/core/styles.css';

import { router } from './router';

import { RouterProvider } from 'react-router-dom';

/** Root DOM element for the SPA. */
const rootEl = document.getElementById('root');

if (!rootEl) {
  throw new Error('Could not find #root element to mount React app.');
}

/** React root instance used by React 18 concurrent rendering. */
const root = ReactDOM.createRoot(rootEl);

root.render(
  <React.StrictMode>
    <MantineProvider defaultColorScheme="light">
      <RouterProvider router={router} />
    </MantineProvider>
  </React.StrictMode>,
);
